import { LitElement, html, css, nothing } from "lit";
import { property, customElement } from "lit/decorators.js";

import "@maersk-global/mds-components-core/mc-modal";
import { FleetAlarm } from "../../src/models/types/voy-fleet-alarm-model.types";
import { getAuditLogMessage, getNotificationMessage } from "../acitivity-log/helper";
import { VoyFleetAlarmModel } from "../../src/models/voy-fleet-alarm-model";
import { AuditLog } from "../../src/services/types/fleet-weather-routing-notification.types";
import { VoyFleetNotificationModel } from "../../src/models/voy-fleet-notification-model";
import { AuthService } from "../../src/services/auth-service";

@customElement("voy-feature-add-note-popup")
export class VoyFeatureAddNote extends LitElement {
  @property({ type: Boolean, reflect: true }) shown: boolean = true;
  @property({ attribute: false }) selected: string = "";
  @property({ type: Object }) alarm: FleetAlarm | null = null;
  @property({ type: Object }) auditLog: AuditLog | null = null;
  @property({ attribute: false }) private _comment: string = "";
  @property({ attribute: false }) private submitted: boolean = false;
  @property({ type: Boolean, reflect: true }) showCloseIcon: boolean = true;


  constructor() {
    super();
    this._handleSave = this._handleSave.bind(this);
  }

  static get styles() {
    return [
      css`
        .comment {
          font-family: "MaerskText";
          width: 380px;
          height: 100%;
          border: 1px solid #CFCFCF;
          line-height: 20px;
          resize: vertical;
          border-radius: 6px;
          margin-top: 16px;
        }
        .error {
          color: red;
          font-size: 12px;
          margin-top: 8px;
        }
      `,
    ];
  }

  render() {
    if(!this.alarm && !this.auditLog) return nothing;
    return html`${this._renderFeedbacktModal()}`;
  }
  private _renderFeedbacktModal() {
    const notificationMessage = this.alarm ? getNotificationMessage(this.alarm) : this.auditLog ? getAuditLogMessage(this.auditLog,true) : '';
    return html`<mc-modal
      heading=${notificationMessage}
      ?open=${this.shown}
      dimension="small"
      width="443px"
      height="350px"
      backdropcloseactiondisabled
      escapecloseactiondisabled
      entercloseactiondisabled
      ?hiddenclose=${!this.showCloseIcon}
      @closing=${() => {
        this.dispatchEvent(new Event("close"));
      }}
    >
      ${this._renderModalContent()}
        <mc-button
          focusstartanchor
          slot="primaryAction"
          appearance="primary"
          variant="filled"
          ?disabled=${!this._comment}
          @click=${this._handleSave}
          >Save</mc-button
        >
    </mc-modal> `;
  }

  private async _handleSave() {
    if(!this.alarm && !this.auditLog) return;
    if (!this._comment) {
      this.submitted = false;
      return;
    }
    this.submitted = true;
    
    if(this.alarm)
      await VoyFleetAlarmModel!.updateAlarm(this.alarm.id, this.alarm.alarmState, "Note added", this._comment);
    else if(this.auditLog){
      const payload = this.createPayload(this.auditLog);
      await VoyFleetNotificationModel!.updateWeatherRoutingNotifications(payload);
    }
      
    this.dispatchEvent(new Event("close"));
  }

  private createPayload(auditLog: AuditLog) {
    const userName = AuthService.getCurrentUserdisplayName();
    let existingMetadata: Array<{ comment: string; User: string; createdAt: number }> = [];

      const parsedMetadata = auditLog.notes ? JSON.parse(auditLog.notes) : [];
      existingMetadata = Array.isArray(parsedMetadata) ? parsedMetadata : [];

    const newNote = {
      comment: this._comment,
      user: userName,
      createdAt: Date.now(),
    };

     // Combine existing notes with the new note
    const updatedMetadata = [...existingMetadata, newNote];

    return {
      updated_by: userName,
      id: auditLog.id,
      status: auditLog.status,
      notes: JSON.stringify(updatedMetadata),
    };
  }

  private _renderModalContent() {
    return html`
                <div class="feedback-icon">        
                </div>
                    <div class="comment-input">
                        <div class="name">Type in the below field to add a note</div>
                            <textarea class="comment" placeholder="Please add a note" @input = ${(evt: {
                              target: { value: string };
                            }) =>
                              (this._comment =
                                evt.target.value.trim())}></textarea> 
                              ${this.submitted && !this._comment? html`<div class="error">Please add a note before saving.</div>`: nothing}
                         </div>
                    </div>
        `;
  }
}
